import { ProjectRole } from './types';

type RoleSource = { role: ProjectRole } | null | undefined;

/**
 * Derives the current user's effective role for the active project from the
 * already-authenticated project context response (see mapApiProjectToProject)
 * rather than any client-side claim or storage.
 */
export function useProjectRole(project: RoleSource): ProjectRole | null {
  return project?.role ?? null;
}
